export const disableConsole = () => {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    window['console']['log'] = function () {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    window['console']['error'] = function () {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    window['console']['debug'] = function () {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    window['console']['info'] = function () {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    window['console']['trace'] = function () {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    window['console']['warn'] = function () {};
  }
};
